webpackJsonp([319],{

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingExaminationTable_vue__ = __webpack_require__(3048);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012c5307_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingExaminationTable_vue__ = __webpack_require__(5640);
function injectStyle (ssrContext) {
  __webpack_require__(5638)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-012c5307"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfTrainingExaminationTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_012c5307_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfTrainingExaminationTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfTrainingExaminationTable',
  data: function data() {
    return {
      activeTab: 'pending',
      counts: { pending: 0, completed: 0 },
      countsLoaded: false,
      exams: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      loading: false,
      loadFailed: false,
      startingExamId: null,
      requestId: 0
    };
  },
  created: function created() {
    this.fetchExams();
  },
  beforeDestroy: function beforeDestroy() {
    this.requestId++;
  },

  methods: {
    fetchExams: function fetchExams() {
      var _this = this;

      var requestId = ++this.requestId;
      this.loading = true;
      this.loadFailed = false;
      this.exams = [];
      return request.common('getSelfTrainingExams', {
        state: this.activeTab,
        current_page: this.currentPage,
        per_page: this.pageSize
      }).then(function (res) {
        if (requestId !== _this.requestId) return;
        var data = res && res.data ? res.data : {};
        _this.exams = Array.isArray(data.data) ? data.data : [];
        _this.total = Number(data.total) || 0;
        _this.currentPage = Number(data.current_page) || _this.currentPage;
        var counts = data.counts || {};
        _this.counts = { pending: Number(counts.pending) || 0, completed: Number(counts.completed) || 0 };
        _this.countsLoaded = true;
      }).catch(function () {
        if (requestId !== _this.requestId) return;
        _this.loadFailed = true;
        _this.total = 0;
      }).finally(function () {
        if (requestId === _this.requestId) _this.loading = false;
      });
    },
    changeTab: function changeTab(tab) {
      if (tab === this.activeTab) return;
      this.activeTab = tab;
      this.currentPage = 1;
      return this.fetchExams();
    },
    changePage: function changePage(page) {
      this.currentPage = page;
      return this.fetchExams();
    },
    startExam: function startExam(exam) {
      var _this2 = this;

      if (this.startingExamId !== null || this.activeTab !== 'pending' || this.loading) return;
      this.startingExamId = exam.id;
      var continuing = exam.action === 'continue';
      return request.common('startSelfTrainingExam', { id: exam.id }).then(function (res) {
        var record = res.data || {};
        var recordId = record.record_id || record.id || exam.record_id;
        var attemptId = record.attemptId || record.attempt_id;
        _this2.$set(exam, 'record_id', recordId);
        _this2.$set(exam, 'record_status', record.status || 1);
        _this2.$set(exam, 'action', 'continue');
        _this2.$message.info(continuing ? '已恢复答卷' : '答卷已准备好');
        var query = {};
        if (recordId) query.record_id = recordId;
        if (attemptId) query.attemptId = attemptId;
        if (_this2.$router && _this2.$router.push) {
          _this2.$router.push({ path: '/training/self-examination/' + exam.id, query: query });
        }
        return _this2.fetchExams();
      }).catch(function () {
        // 请求封装已显示错误，保持原来的开始/继续状态，允许重试。
      }).finally(function () {
        _this2.startingExamId = null;
      });
    },
    viewResult: function viewResult(exam) {
      if (!exam.record_id || !this.$router || !this.$router.push) return;
      this.$router.push('/training/self-examination/' + exam.id + '/result/' + exam.record_id);
    }
  }
});

/***/ }),

/***/ 5638:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5639);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("fd038520", content, true, {});

/***/ }),

/***/ 5639:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".self-training-exams[data-v-012c5307]{min-height:calc(100vh - 160px);padding:26px 30px;background:#f5f7fa;color:#183153}.exam-header h2[data-v-012c5307]{margin:0 0 8px;font-size:20px;font-weight:600}.exam-header p[data-v-012c5307]{margin:0;color:#7b8ba1;font-size:14px}.exam-tabs[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:24px;margin:22px 0 16px;border-bottom:1px solid #e1e6ed}.exam-tab[data-v-012c5307]{padding:8px 0 13px;border:0;border-bottom:2px solid transparent;background:transparent;color:#75849a;cursor:pointer;font-size:14px}.exam-tab.active[data-v-012c5307]{color:#2165ff;border-bottom-color:#2165ff}.exam-tab[data-v-012c5307]:focus-visible{outline:2px solid #2165ff;outline-offset:2px}.exam-count[data-v-012c5307]{display:inline-block;min-width:20px;margin-left:5px;padding:0 5px;border-radius:12px;line-height:20px;font-size:12px}.exam-count.pending[data-v-012c5307]{color:#ef8b27;background:#fff0df}.exam-count.completed[data-v-012c5307]{color:#1aa868;background:#def5e9}.exam-list[data-v-012c5307]{min-height:180px}.exam-card[data-v-012c5307]{-ms-flex-align:center;gap:18px;margin-bottom:14px;padding:20px;border:1px solid #edf0f5;border-radius:12px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(24,49,83,.04);box-shadow:0 1px 2px rgba(24,49,83,.04)}.exam-card[data-v-012c5307],.exam-icon[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center}.exam-icon[data-v-012c5307]{-webkit-box-flex:0;-ms-flex:0 0 44px;flex:0 0 44px;-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:44px;border-radius:8px;background:#e8efff;color:#2165ff;font-size:24px}.exam-content[data-v-012c5307]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.exam-content h3[data-v-012c5307]{margin:0 0 8px;overflow-wrap:break-word;font-size:14px;font-weight:500}.exam-meta[data-v-012c5307],.exam-result[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px 16px;color:#7b8ba1;font-size:12px}.exam-meta i[data-v-012c5307],.exam-result i[data-v-012c5307]{margin-right:4px}.exam-result[data-v-012c5307]{margin-top:8px}.exam-action[data-v-012c5307]{-ms-flex-negative:0;flex-shrink:0;border-radius:8px;background:#2165ff;border-color:#2165ff}.exam-result-actions[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px}.exam-result-action[data-v-012c5307]{border-radius:8px}.exam-empty[data-v-012c5307]{padding:60px 20px;text-align:center;color:#909eb1}.exam-empty i[data-v-012c5307]{font-size:32px}.exam-pagination[data-v-012c5307]{margin-top:22px;text-align:center}@media (max-width:768px){.self-training-exams[data-v-012c5307]{padding:20px 16px}.exam-card[data-v-012c5307]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px;padding:16px}.exam-content[data-v-012c5307]{-ms-flex-preferred-size:calc(100% - 60px);flex-basis:calc(100% - 60px)}.exam-action[data-v-012c5307],.exam-result-actions[data-v-012c5307]{margin-left:56px}}", "", {"version":3,"sources":["/workspace/src/views/training/pages/exam/SelfTrainingExaminationTable.vue"],"names":[],"mappings":"AACA,sCAAsC,+BAA+B,kBAAkB,mBAAmB,aAAa,CACtH,AACD,iCAAiC,eAAe,eAAe,eAAe,CAC7E,AACD,gCAAgC,SAAS,cAAc,cAAc,CACpE,AACD,4BAA4B,oBAAoB,oBAAoB,aAAa,SAAS,mBAAmB,+BAA+B,CAC3I,AACD,2BAA2B,mBAAmB,SAAS,oCAAoC,uBAAuB,cAAc,eAAe,cAAc,CAC5J,AACD,kCAAkC,cAAc,2BAA2B,CAC1E,AACD,yCAAyC,0BAA0B,kBAAkB,CACpF,AACD,6BAA6B,qBAAqB,eAAe,gBAAgB,cAAc,mBAAmB,iBAAiB,cAAc,CAChJ,AACD,qCAAqC,cAAc,kBAAkB,CACpE,AACD,uCAAuC,cAAc,kBAAkB,CACtE,AACD,4BAA4B,gBAAgB,CAC3C,AACD,4BAA0G,sBAAsB,AAAmB,SAAS,mBAAmB,aAAa,yBAAyB,mBAAmB,gBAAgB,gDAAiD,uCAAwC,CAChV,AACD,wDAF4B,oBAAoB,oBAAoB,aAAa,yBAAyB,AAAsB,kBAAmB,CAGlJ,AADD,4BAAiF,mBAAmB,kBAAkB,cAAc,AAAyB,sBAAsB,AAAmB,wBAAwB,qBAAqB,uBAAuB,YAAY,kBAAkB,mBAAmB,cAAc,cAAc,CACtV,AACD,+BAA+B,mBAAmB,WAAW,OAAO,WAAW,CAC9E,AACD,kCAAkC,eAAe,yBAAyB,eAAe,eAAe,CACvG,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,cAAc,cAAc,cAAc,CAC1L,AACD,8DAA8D,gBAAgB,CAC7E,AACD,8BAA8B,cAAc,CAC3C,AACD,8BAA8B,oBAAoB,cAAc,kBAAkB,mBAAmB,oBAAoB,CACxH,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,oBAAoB,cAAc,yBAAyB,sBAAsB,mBAAmB,QAAQ,CACtM,AACD,qCAAqC,iBAAiB,CACrD,AACD,6BAA6B,kBAAkB,kBAAkB,aAAa,CAC7E,AACD,+BAA+B,cAAc,CAC5C,AACD,kCAAkC,gBAAgB,iBAAiB,CAClE,AACD,yBACA,sCAAsC,iBAAiB,CACtD,AACD,4BAA4B,mBAAmB,eAAe,SAAS,YAAY,CAClF,AACD,+BAA+B,0CAA0C,4BAA4B,CACpG,AAGD,oEAAsC,gBAAgB,CACrD,CACA","file":"SelfTrainingExaminationTable.vue","sourcesContent":["\n.self-training-exams[data-v-012c5307]{min-height:calc(100vh - 160px);padding:26px 30px;background:#f5f7fa;color:#183153\n}\n.exam-header h2[data-v-012c5307]{margin:0 0 8px;font-size:20px;font-weight:600\n}\n.exam-header p[data-v-012c5307]{margin:0;color:#7b8ba1;font-size:14px\n}\n.exam-tabs[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:24px;margin:22px 0 16px;border-bottom:1px solid #e1e6ed\n}\n.exam-tab[data-v-012c5307]{padding:8px 0 13px;border:0;border-bottom:2px solid transparent;background:transparent;color:#75849a;cursor:pointer;font-size:14px\n}\n.exam-tab.active[data-v-012c5307]{color:#2165ff;border-bottom-color:#2165ff\n}\n.exam-tab[data-v-012c5307]:focus-visible{outline:2px solid #2165ff;outline-offset:2px\n}\n.exam-count[data-v-012c5307]{display:inline-block;min-width:20px;margin-left:5px;padding:0 5px;border-radius:12px;line-height:20px;font-size:12px\n}\n.exam-count.pending[data-v-012c5307]{color:#ef8b27;background:#fff0df\n}\n.exam-count.completed[data-v-012c5307]{color:#1aa868;background:#def5e9\n}\n.exam-list[data-v-012c5307]{min-height:180px\n}\n.exam-card[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:18px;margin-bottom:14px;padding:20px;border:1px solid #edf0f5;border-radius:12px;background:#fff;-webkit-box-shadow:0 1px 2px rgba(24,49,83,0.04);box-shadow:0 1px 2px rgba(24,49,83,0.04)\n}\n.exam-icon[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 44px;flex:0 0 44px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:44px;border-radius:8px;background:#e8efff;color:#2165ff;font-size:24px\n}\n.exam-content[data-v-012c5307]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.exam-content h3[data-v-012c5307]{margin:0 0 8px;overflow-wrap:break-word;font-size:14px;font-weight:500\n}\n.exam-meta[data-v-012c5307],.exam-result[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px 16px;color:#7b8ba1;font-size:12px\n}\n.exam-meta i[data-v-012c5307],.exam-result i[data-v-012c5307]{margin-right:4px\n}\n.exam-result[data-v-012c5307]{margin-top:8px\n}\n.exam-action[data-v-012c5307]{-ms-flex-negative:0;flex-shrink:0;border-radius:8px;background:#2165ff;border-color:#2165ff\n}\n.exam-result-actions[data-v-012c5307]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px\n}\n.exam-result-action[data-v-012c5307]{border-radius:8px\n}\n.exam-empty[data-v-012c5307]{padding:60px 20px;text-align:center;color:#909eb1\n}\n.exam-empty i[data-v-012c5307]{font-size:32px\n}\n.exam-pagination[data-v-012c5307]{margin-top:22px;text-align:center\n}\n@media (max-width: 768px){\n.self-training-exams[data-v-012c5307]{padding:20px 16px\n}\n.exam-card[data-v-012c5307]{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px;padding:16px\n}\n.exam-content[data-v-012c5307]{-ms-flex-preferred-size:calc(100% - 60px);flex-basis:calc(100% - 60px)\n}\n.exam-action[data-v-012c5307]{margin-left:56px\n}\n.exam-result-actions[data-v-012c5307]{margin-left:56px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"self-training-exams"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"exam-tabs",attrs:{"role":"tablist","aria-label":"问卷分类"}},[_c('button',{staticClass:"exam-tab",class:{ active: _vm.activeTab === 'pending' },attrs:{"type":"button","role":"tab","aria-selected":_vm.activeTab === 'pending'},on:{"click":function($event){return _vm.changeTab('pending')}}},[_vm._v("\n      待完成 "),_c('span',{staticClass:"exam-count pending"},[_vm._v(_vm._s(_vm.countsLoaded ? _vm.counts.pending : '—'))])]),_vm._v(" "),_c('button',{staticClass:"exam-tab",class:{ active: _vm.activeTab === 'completed' },attrs:{"type":"button","role":"tab","aria-selected":_vm.activeTab === 'completed'},on:{"click":function($event){return _vm.changeTab('completed')}}},[_vm._v("\n      已完成 "),_c('span',{staticClass:"exam-count completed"},[_vm._v(_vm._s(_vm.countsLoaded ? _vm.counts.completed : '—'))])])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"exam-list",attrs:{"role":"tabpanel"}},[_vm._l((_vm.exams),function(exam){return _c('article',{key:exam.id,staticClass:"exam-card"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"exam-content"},[_c('h3',[_vm._v(_vm._s(exam.title))]),_vm._v(" "),_c('div',{staticClass:"exam-meta"},[_c('span',[_c('i',{staticClass:"el-icon-question"}),_vm._v(_vm._s(exam.question_count)+" 题")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-time"}),_vm._v("考试时限："+_vm._s(exam.exam_duration)+" 分钟")]),_vm._v(" "),(exam.created_at)?_c('span',[_c('i',{staticClass:"el-icon-date"}),_vm._v("创建时间："+_vm._s(exam.created_at))]):_vm._e()]),_vm._v(" "),(_vm.activeTab === 'completed')?_c('div',{staticClass:"exam-result"},[(exam.submitted_at)?_c('span',[_vm._v("完成时间："+_vm._s(exam.submitted_at))]):_vm._e(),_vm._v(" "),(exam.open_book_exam === 2 && exam.full_score > 0)?_c('span',[_vm._v("\n            得分："+_vm._s(exam.score)+" / "+_vm._s(exam.full_score)+"\n          ")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.activeTab === 'pending')?_c('el-button',{staticClass:"exam-action",attrs:{"type":"primary","loading":_vm.startingExamId === exam.id,"disabled":_vm.startingExamId !== null || _vm.loading},on:{"click":function($event){return _vm.startExam(exam)}}},[_vm._v("\n        "+_vm._s(exam.action === 'continue' ? '继续考试' : '开始考试')+"\n      ")]):_c('div',{staticClass:"exam-result-actions"},[_c('el-tag',{attrs:{"type":exam.record_status === 3 ? 'warning' : 'success',"size":"small"}},[_vm._v("\n          "+_vm._s(exam.record_status === 3 ? '未通过' : '已完成')+"\n        ")]),_vm._v(" "),_c('el-button',{staticClass:"exam-result-action",attrs:{"type":"primary","plain":"","size":"small","disabled":!exam.record_id},on:{"click":function($event){return _vm.viewResult(exam)}}},[_vm._v("\n          查看详情\n        ")])],1)],1)}),_vm._v(" "),(!_vm.loading && _vm.loadFailed)?_c('div',{staticClass:"exam-empty"},[_c('p',[_vm._v("问卷加载失败")]),_vm._v(" "),_c('el-button',{staticClass:"exam-retry",attrs:{"size":"small","plain":"","type":"primary"},on:{"click":_vm.fetchExams}},[_vm._v("重新加载")])],1):(!_vm.loading && !_vm.exams.length)?_c('div',{staticClass:"exam-empty"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.activeTab === 'pending' ? '暂无待完成问卷' : '暂无已完成问卷'))])]):_vm._e()],2),_vm._v(" "),(!_vm.loadFailed && _vm.total > _vm.pageSize)?_c('el-pagination',{staticClass:"exam-pagination",attrs:{"background":"","layout":"prev, pager, next, total","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total,"disabled":_vm.loading},on:{"current-change":_vm.changePage}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"exam-header"},[_c('h2',[_vm._v("我的问卷")]),_vm._v(" "),_c('p',[_vm._v("查看并完成分配给你的问卷")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam-icon"},[_c('i',{staticClass:"el-icon-document"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/self-training-examination.34562defcedde4d0bf98.js